module.exports = __webpack_public_path__ + "img/mobile-notification-img.d2168bb6.png";